import { useEffect, useState, useRef } from "react";
import { MODAL_TYPE, MODAL_ANIMATION_TIME_MS } from "../constants";

export const useRenderManagement = ({
  open,
  modalType,
  elementReceivingFocusOnClose,
  forceDOMRewrite
}) => {
  const [shouldRenderModal, setShouldRenderModal] = useState(open);
  const [shouldRenderPageOverlay, setShouldRenderPageOverlay] = useState(open);

  const derenderTimeout = useRef(null);
  const firstRender = useRef(true);

  useEffect(() => {
    const derenderNow = () => {
      setShouldRenderModal(!forceDOMRewrite);
      setShouldRenderPageOverlay(false);
      elementReceivingFocusOnClose?.focus();
    };

    const derenderWithAnimationDelay = () => {
      clearTimeout(derenderTimeout.current);
      derenderTimeout.current = setTimeout(() => {
        derenderNow();
      }, MODAL_ANIMATION_TIME_MS);
    };

    const manageDerender = () => {
      modalType === MODAL_TYPE.SIDE_RIGHT
        ? derenderWithAnimationDelay()
        : derenderNow();
    };

    if (firstRender.current !== true) {
      if (!open) {
        manageDerender();
      } else {
        clearTimeout(derenderTimeout.current);
        setShouldRenderPageOverlay(true);
        setShouldRenderModal(true);
      }
    } else {
      setShouldRenderPageOverlay(false);
      setShouldRenderModal(false);
    }
  }, [open, modalType, elementReceivingFocusOnClose, forceDOMRewrite]);

  useEffect(() => {
    firstRender.current = false;
  }, []);
  return { shouldRenderModal, shouldRenderPageOverlay };
};
